<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <h1 class="mb-6 mt-0">
          Rodiče
        </h1>

        <p class="mb-6">
          Vyplňte prosím údaje o vašich rodičích
        </p>

        <v-row>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="noInformation"
              row>
              <v-radio color="blue lighten-1"
                       label="Chci vyplnit (i částečně)"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nemám žádné informace"
                       :value="true" />
            </VRadioWithValidation>
          </v-col>
        </v-row>

        <h3>
          Matka
        </h3>

        <v-row>
          <v-col
            cols="2">
            <VTextFieldWithValidation
              :rules="noInformation === 2 ? 'required' : ''"
              :disabled="noInformation === true"
              v-model="parents.mother.yearBirth"
              label="Rok narození"
              mode="lazy" />
          </v-col>
          <v-col
            cols="6">
            <v-row v-if="parents.mother.sicks.length">
              <v-col>
                <v-chip
                  :disabled="noInformation === true"
                  class="ma-2"
                  v-for="(sick, i) in parents.mother.sicks"
                  :key="sick[i]"
                  close
                  @click:close="removeChip(i, 'mother')">
                  {{ sick.name }},
                  {{ sick.age }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col
                class="pt-0"
                cols="6">
                <v-text-field
                  :disabled="noInformation === true"
                  v-model="parents.mother.adding.name"
                  label="Onemocnění" />
              </v-col>
              <v-col
                class="pt-0"
                cols="4">
                <v-text-field
                  :disabled="noInformation === true"
                  v-model="parents.mother.adding.age"
                  label="Věk diagnózy" />
              </v-col>
              <v-col
                class="pt-0"
                cols="2">
                <v-btn :disabled="noInformation === true"
                       fab
                       small
                       color="green darken-1 text--white"
                       @click="addSick('mother')">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2">
            <VRadioWithValidation
              :rules="noInformation === 2 ? 'required' : ''"
              :disabled="noInformation === true"
              v-model="parents.mother.alive"
              row
              custom-class="mt-2">
              <v-radio color="blue lighten-1"
                       label="Žije"
                       :value="true" />
              <v-radio color="blue lighten-1"
                       label="Nežije"
                       :value="1" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="2"
            v-if="parents.mother.alive === 1">
            <VTextFieldWithValidation
              :rules="(parents.mother.alive === 1 && noInformation === 2) ? 'required' : ''"
              :disabled="noInformation === true"
              v-model="parents.mother.ageDeath"
              label="Věk úmrtí"
              mode="lazy" />
          </v-col>
        </v-row>

        <h3>
          Otec
        </h3>

        <v-row>
          <v-col
            cols="2">
            <VTextFieldWithValidation
              :rules="noInformation === 2 ? 'required' : ''"
              :disabled="noInformation === true"
              v-model="parents.father.yearBirth"
              label="Rok narození"
              mode="lazy" />
          </v-col>
          <v-col
            cols="6">
            <v-row v-if="parents.father.sicks.length">
              <v-col>
                <v-chip
                  :disabled="noInformation === true"
                  class="ma-2"
                  v-for="(sick, i) in parents.father.sicks"
                  :key="sick[i]"
                  close
                  @click:close="removeChip(i, 'father')">
                  {{ sick.name }},
                  {{ sick.age }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col
                class="pt-0"
                cols="6">
                <v-text-field
                  :disabled="noInformation === true"
                  v-model="parents.father.adding.name"
                  label="Onemocnění" />
              </v-col>
              <v-col
                class="pt-0"
                cols="4">
                <v-text-field
                  :disabled="noInformation === true"
                  v-model="parents.father.adding.age"
                  label="Věk diagnózy" />
              </v-col>
              <v-col
                class="pt-0"
                cols="2">
                <v-btn :disabled="noInformation === true"
                       fab
                       small
                       color="green darken-1 text--white"
                       @click="addSick('father')">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2">
            <VRadioWithValidation
              :rules="noInformation === 2 ? 'required' : ''"
              :disabled="noInformation === true"
              v-model="parents.father.alive"
              row
              custom-class="mt-2">
              <v-radio color="blue lighten-1"
                       label="Žije"
                       :value="true" />
              <v-radio color="blue lighten-1"
                       label="Nežije"
                       :value="1" />
            </VRadioWithValidation>
          </v-col>
          <v-col
            cols="2"
            v-if="parents.father.alive === 1">
            <VTextFieldWithValidation
              :disabled="noInformation === true"
              :rules="(parents.father.alive === 1 && noInformation === 2) ? 'required' : ''"
              v-model="parents.father.ageDeath"
              label="Věk úmrtí"
              mode="lazy" />
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheParents',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      noInformation: 2,
      parents: {
        mother: {
          yearBirth: '',
          ageDeath: '',
          adding: {
            name: '',
            age: '',
          },
          sicks: [],
          alive: null,
        },
        father: {
          yearBirth: '',
          ageDeath: '',
          adding: {
            name: '',
            age: '',
          },
          sicks: [],
          alive: null,
        },
      }
    };
  },
  computed: {
    parentsToSend() {
      let mother = {};
      let father = {};
      mother = {
        yearBirth: this.parents.mother.yearBirth,
        diseaseType: JSON.stringify(this.parents.mother.sicks),
        relationship: 'mother',
        ageDiagnosis: '1',
        ageDeath: this.parents.mother.ageDeath,
        alive: this.parents.mother.alive !== 1
      };
      father = {
        yearBirth: this.parents.father.yearBirth,
        diseaseType: JSON.stringify(this.parents.father.sicks),
        relationship: 'father',
        ageDiagnosis: '1',
        ageDeath: this.parents.father.ageDeath,
        alive: this.parents.father.alive !== 1
      };

      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        mother,
        father,
        noInformation: this.noInformation !== 2
      });
    }
  },
  methods: {
    addSick(parent) {
      if (!this.parents[parent].adding.age.length) {
        return;
      }
      this.parents[parent].sicks.push({
        name: this.parents[parent].adding.name,
        age: this.parents[parent].adding.age,
      });

      this.parents[parent].adding.name = '';
      this.parents[parent].adding.age = '';
    },
    removeChip(index, parent) {
      this.parents[parent].sicks.splice(index, 1);
    },
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.parentsToSend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/parentsanamnesis', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/parentsanamnesis', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;
      this.noInformation = data.noInformation === false ? 2 : true;
      if (data.mother) {
        this.parents.mother.yearBirth = data.mother.yearBirth;
        this.parents.mother.ageDeath = data.mother.ageDeath;
        this.parents.mother.alive = data.mother.alive === false ? 1 : true;
        this.parents.mother.sicks = JSON.parse(data.mother.diseaseType);
      }
      if (data.father) {
        this.parents.father.name = data.father.firstName;
        this.parents.father.yearBirth = data.father.yearBirth;
        this.parents.father.ageDeath = data.father.ageDeath;
        this.parents.father.alive = data.father.alive === false ? 1 : true;
        this.parents.father.sicks = JSON.parse(data.father.diseaseType);
      }
      if (data.noInformation === true) {
        this.parents.mother.alive = null;
        this.parents.father.alive = null;
      }
    });
  }
};
</script>
